import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { SportsFilter, Sportshome, ConfigService, SportsHomeService, SportsFilterService, SocketService, EventStatus, MarketStatus,SharedService } from 'baseline-lib';
import { NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Global } from '../../../global/global';


/**
 * Generated class for the SportsFilterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'sports-filter',
  templateUrl: 'sports-filter.html'
})
export class SportsFilterComponent {
  @Output() onsportsclickeventlisting: EventEmitter<any> = new EventEmitter<any>();

  @Input() frompage : string;
  @Input() fromhome : any;
  _sportsFilter: SportsFilter;
  params : any;
  sportsHomeObj: Sportshome;
  updates_sub : any;
  showFreeBet: boolean;
  id : number;
  tid : number;
  duraId : number;
  dataObj : any;
  sportsfullDetailDataObj : any;
  loader : any;
  showliveloader : boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams,public _sharedService: SharedService,public loadingCtrl : LoadingController,
    public _configService : ConfigService, public _sportsFilterService: SportsFilterService,public viewController : ViewController,
    public translate : TranslateService, public _sportsHomeService : SportsHomeService, public _socketService : SocketService, public globalData: Global,) {
      
      this.sportsHomeObj = new Sportshome();
     
      this.viewController.didEnter.subscribe(() => {
        if(this.globalData.isBetAdded){
          this.globalData.isLoaderShownHomepage = true;
          this.globalData.isBetAdded = false;
          this.ngOnInit(); 
        }
      });
      
  }

  ngOnChanges(changes: SimpleChanges){

    let cx = changes.frompage;
    this.dataObj = changes.fromhome;
    this.globalData.isLoaderShownHomepage = true;

    if(this.dataObj != null && this.dataObj != undefined && this.dataObj.currentValue != undefined){
      if(this.globalData.inPlay){ //live sports
        this.id = this.dataObj.currentValue[0];
        this.duraId = this.dataObj.currentValue[1];
      }else{ // sports
        this.id = this.dataObj.currentValue[0];
        this.tid = this.dataObj.currentValue[1];
      }
      this.ngOnInit();
    }
  }
  ngOnInit() {

     // Get free bet
     this._sharedService.showFreeBet.subscribe(data => {
       if (data == true)
         this.showFreeBet = true;
       else {
        this.showFreeBet = false;
       //   if(!(this._bannerSharedService.bannerObj.top_banners.length > 0))
       //     this._bannerSharedService.getBannerLists(this._sharedService.selectedGameType.gtid);
       }          
     });

     if(this.globalData.inPlay){
      if(!this.id || this.id == undefined){
      //   if(!this.loader){
      //   this.loader = this.loadingCtrl.create({
      //     content: "Please Wait",
      //   });
      //   this.loader.present();
      // }
      // this.showliveloader = true;
      return;
      }else{
          try {
            // this.loader.dismiss();
            // this.showliveloader = false;
          } catch (error) {
            
          }
      }
     }
  
    console.log('ionViewDidLoad SportsDetailPage');
    this._sportsHomeService.setSportsGame();
    this.sportsHomeObj = this._sportsHomeService.sportshomeobj;
    this._sportsFilter = this._sportsFilterService._sportsFilter;

    if(this.id != null && this.tid !=null){ //filtered sports
      this.params = { "id": this.id, "tid": this.tid };
      this._sportsFilterService.filterChange(this.params, "").subscribe(data=>
        {
          this._sportsFilter = data;
        }); 
    }else if(this.globalData.inPlay && this.id != null && this.duraId != null){ // live sports
      this.params = { "id": this.id,"duraId": this.duraId };
      this._sportsFilterService.filterChange(this.params, "").subscribe(data=>
        {
          this._sportsFilter = data;
        }); 
    }else if(!this.globalData.inPlay){ // default sports
      this.params = { "duraId": 168 };
      // if(!this.globalData.hideHomeLoader){
      // this.loader = this.loadingCtrl.create({
      //       content: "Please Wait",
      //     });
      //     this.loader.present();
      //     console.log("ganesh","customstart");

      //   }
      this._sportsFilterService.filterChange(this.params, "recent").subscribe(data=>
        {
          // if(!this.globalData.hideHomeLoader){
          // this.loader.dismiss();
          // console.log("ganesh","customend");

          // }
          this._sportsFilter = data;
        }); 
    }
   
    //Start sockets updates.
    this.updates_sub = this._socketService.updates.subscribe(data => {

      if (data) {
        let _socketData = JSON.parse(data.toString());
        if (this._sportsFilter) {
          if (this._sportsFilter.gameListing) {

            var league;
            this._sportsFilter.gameListing.every((_gameitem, index) => {
              league = _gameitem.leagues.find(a => a.leagueid == _socketData.tid);
              if (league)
                return false;
              else
                return true;
            });

            if (league) {
              if (league.events) {
                var nomarket = false;
                var _event = league.events.find(a => a.eventid == _socketData.id);
                if (_event) {

                  // for making all markets suspended
                  if (!_socketData.isscr && (_socketData.md == MarketStatus.AllSuspended || _socketData.amid == MarketStatus.AllSuspended)) {
                    _event.mli.forEach((_gameitem, index) => {
                      _gameitem.sli.forEach(a => a.status = MarketStatus.Suspended);
                      _gameitem.status = MarketStatus.Suspended;
                      return true;
                    });
                    return;
                  }
                  
                  // check market by market id & if not found check by market name 
                  var _market = _event.mli.find(a => a.amid == _socketData.amid);
                  if (!_market)
                    _market = _event.mli.find(a => a.mn == _socketData.mn);

                  if (!_market)
                    nomarket = true;
                  else
                    nomarket = false;

                  _market = this._socketService.processSocket(_socketData, _market, _event);

                  if (nomarket && !_socketData.isscr && _market && _event.eventid == _socketData.id) {
                    _event.mli.unshift(_market);
                  }
                }
                // if event not found
                else
                  this.getNewEvents(_socketData);
              }
              // if leagues event not found
              else
                this.getNewEvents(_socketData);
            }
            // if leagues not found
            else
              this.getNewEvents(_socketData);

          }
        }
      }
    });

    // on event finish update game wise event counts
    this._socketService.eventFinish.subscribe(_socketdata => {
      if (_socketdata) {
        this._sportsHomeService.getGamesByGameType();
        //this.reloadLiveEvents();
      }
    });
  }
 
  getNewEvents(_socketData) {
    if (!_socketData.isscr) {
      // check for new event 
      switch (_socketData.st) {
        case EventStatus.INPROGRESS:
          this._sportsHomeService.getGamesByGameType();
          /* if(this._sportsFilter._game)
           {
             this._sportMessageServices.getLiveInplayEvent(this._sportsFilter._game.gameid)
             .subscribe(
               data => {
                   this._sharedService.hideContentLoader();
                   if (data.eli) {
                       var _games = this._parserService.parseEvents(data.eli, gameType.sports, true);
                       if (_games) {
                           if (_games.length > 0) {
                               this._sportsFilter._game = _games[0];
                           }
                       }
                       this._socketService.eventFinish.next(true);
                   }
                   else {
                       this._sportsFilter._exception = data.msg;
                   }
                  
               },
               error => {
                   //this._sharedService.hideLoader();
                   this._sharedService.hideContentLoader();
                   console.log(error);
               });
              }
              else*/
          this.reloadLiveEvents();
          break;
      }
    }
  }

  reloadLiveEvents() {
    // setTimeout(() => {
    //   this.sub = this.route.params.subscribe(params => {
    //     this._sportsFilterService.filterChange(params, this.route.snapshot.url).subscribe(data => {
    //       this._sportsFilter = data;
    //     });

    //   });
    // }
    //   , 3000);
  }

  ngOnDestroy() {
    if (this.updates_sub) {
      this.updates_sub.unsubscribe();
    }
    this.globalData.isBetAdded = false;
  }

  sportsfulldetailclicked(data : any){
    this.sportsfullDetailDataObj = data;
    this.onsportsclickeventlisting.emit(this.sportsfullDetailDataObj);


  }

}



// WEBPACK FOOTER //
// ./src/app/sports/sports-filter/sports-filter.ts